import { styled } from "styled-components";

export const SignUpInputTitle = styled.span`
  font-size: 12px;
  font-weight: 600;

  width: 100px;
`;
